var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height align-center justify-center" },
    [
      _c(
        "v-card",
        { staticClass: "login-card" },
        [
          _c("v-card-text", { staticClass: "d-flex justify-center" }, [
            _c("img", {
              attrs: { src: _vm.logoImage, height: "38", alt: "Corra" },
            }),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: { label: "Логин", required: "" },
                    model: {
                      value: _vm.login,
                      callback: function ($$v) {
                        _vm.login = $$v
                      },
                      expression: "login",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": _vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showPassword ? "text" : "password",
                      label: "Пароль",
                      required: "",
                    },
                    on: {
                      "click:append": function ($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "px-8 py-4 login-button",
                  attrs: {
                    disabled: !_vm.valid,
                    color: "primary",
                    outlined: "",
                  },
                  on: { click: _vm.doLogin },
                },
                [_vm._v(" Войти ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }